import React, { useEffect, useState } from 'react';
import Drawer from '../../../../../component/Drawer';
import dateIcon from '../../../../../assets/image/date-schedule-icon.svg';
import pauseScheduleIcon from '../../../../../assets/image/pause-schedule-icon.svg';
import editIcon from '../../../../../assets/image/edit-icon.png';
import reportPdfIcon from '../../../../../assets/image/report-pdf-icon.svg';
import arrowForwardIcon from '../../../../../assets/image/arrow-forward-icon.svg';
import arrowDownIcon from '../../../../../assets/image/arrow-down-gray-icon.svg';
import Button from '../../../../../component/ui/Button';
import { changeScheduleStatus, getScheduled } from '../../../../../services/reports';
import { capitalizeWords, formatAMPMDate } from '../../../../../utils/constant';
import { toast } from 'react-toastify';

export default function ReportScheduledDrawer({ isOpen, onClose, id, getList }) {
	const [activeTab, setActiveTab] = useState('Schedule History');
	const [isOpenRecipient, setIsOpenRecipient] = useState(false);
	const [loader, setLoader] = useState(false);
	const navTabs = ['Schedule History', 'Activity'];
	const [scheduleDetails, setScheduleDetails] = useState(null);

	const renderTabContent = () => {
		switch (activeTab) {
			case 'Schedule History':
				return <></>;
			case 'Activity':
				return <></>;
			default:
				return null;
		}
	};
	const getScheduleDetails = async () => {
		try {
			const { scheduled_report } = await getScheduled(id);
			if (scheduled_report) {
				setScheduleDetails(scheduled_report);
			}
		} catch (error) {}
	};

	const handleScheduleReport = async (type) => {
		try {
			setLoader(true);
			const res = await changeScheduleStatus(id, type);
			if (res.success) {
				toast.success(res.message);
				getScheduleDetails();
				getList();
			} else {
				toast.error(res.message || 'Something went wrong!');
			}
		} catch (error) {
		} finally {
			setLoader(false);
		}
	};

	useEffect(() => {
		if (id) {
			getScheduleDetails();
		}
	}, [id]);
	return (
		scheduleDetails && (
			<Drawer
				handleViewMoreDetails={''}
				isOpen={isOpen}
				onClose={onClose}
				status={scheduleDetails.status === 'active' ? 'Active' : ''}
				title={'Scheduled Report'}
			>
				<br />
				<div>
					<div
						className="d-flex justify-content-start align-items-start p-3 gap-4 rounded"
						style={{ background: '#F6F6F9', boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.05)' }}
					>
						<img
							width={40}
							height={40}
							src={scheduleDetails.status === 'active' ? dateIcon : pauseScheduleIcon}
							alt="date-icon"
						/>
						<div className="align-items-start">
							<div className="fs-4 fw-light">
								{scheduleDetails.status === 'active'
									? 'The next schedule report will be sent on '
									: 'The report’s scheduler is currently paused.'}
							</div>
							<div className="fs-4 fw-light mt-1 mb-3">
								{scheduleDetails.status === 'active'
									? scheduleDetails.next_run_at !== null && scheduleDetails.next_run_at !== ''
										? formatAMPMDate(scheduleDetails.next_run_at)
										: ''
									: 'Kindly resume it to s=continue scheduling.'}
							</div>
							<div className="d-flex justify-content-start">
								<Button
									type="button"
									loader={loader}
									disabled={loader}
									className="mt-0 btn btn-gray"
									button={
										scheduleDetails.status === 'active' ? 'Pause Schedule' : 'Resume Schedule'
									}
									onClick={() => {
										handleScheduleReport(scheduleDetails.status === 'active' ? 'pause' : 'resume');
									}}
								/>
							</div>
						</div>
					</div>
					<br />
					<hr />
					<div className="d-flex justify-content-start align-items-center gap-4">
						<div className="fs-4 fw-bold text-dark">Schedule Details</div>
						<img
							width={20}
							height={20}
							src={editIcon}
							className="cursor-pointer"
							alt="edit-icon"
						/>
					</div>
					<hr />
					<div className="d-flex justify-content-start align-items-center gap-4 py-3">
						<div className="w-150 fs-4 fw-semibold">Frequency</div>
						<div className="fs-4 fw-light">:</div>
						<div className="fs-4 fw-light">{capitalizeWords(scheduleDetails.frequency)}</div>
					</div>
					<div className="d-flex justify-content-start align-items-center gap-4 py-3">
						<div className="w-150 fs-4 fw-semibold">Start Date</div>
						<div className="fs-4 fw-light">:</div>
						<div className="fs-4 fw-light">
							{scheduleDetails.start_date !== null && scheduleDetails.start_date !== ''
								? formatAMPMDate(scheduleDetails.start_date)
								: ''}
						</div>
					</div>
					<div className="d-flex justify-content-start align-items-center gap-4 py-3">
						<div className="w-150 fs-4 fw-semibold">Format</div>
						<div className="fs-4 fw-light">:</div>
						<img
							width={20}
							height={20}
							src={reportPdfIcon}
							alt="format-icon"
						/>
						<div className=" fs-4 fw-light">{scheduleDetails.file_format.toUpperCase()}</div>
					</div>
					<div
						className="d-flex justify-content-start align-items-center gap-4 py-3 cursor-pointer"
						onClick={() => setIsOpenRecipient(!isOpenRecipient)}
					>
						<div className="fs-4 fw-semibold">Show Recipients</div>
						<img
							width={12}
							height={12}
							src={isOpenRecipient ? arrowDownIcon : arrowForwardIcon}
							alt="arrow-icon"
						/>
					</div>
					{isOpenRecipient && (
						<div className="fs-5 fw-semibold text-black">
							{scheduleDetails.primary_email},
							{scheduleDetails.additional_recipients.length > 0 &&
								scheduleDetails.additional_recipients.map((email) => {
									return {
										email,
									};
								})}
						</div>
					)}
					<br />
					<hr />

					{/* tabs  */}
					<div>
						<ul className="nav mb-4 mt-2">
							{navTabs.map((item, index) => (
								<li
									key={index}
									className="nav-item"
								>
									<div
										className={`nav-link ${activeTab === item && 'active'} cursor-pointer`}
										onClick={(e) => {
											e.preventDefault();
											setActiveTab(item);
										}}
									>
										{item}
									</div>
								</li>
							))}
						</ul>
						<hr
							style={{
								backgroundColor: '#E3E4E5',
								boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
								marginTop: '-5px',
							}}
						/>
						<div>{renderTabContent()}</div>
					</div>
				</div>
			</Drawer>
		)
	);
}
